export default "/images/img-7.jpg?f6859a84e2d5252732308ad58574d7b8";